<template>

    <modal :show="showModal" @closeModal="closeModal">

        <img class="close-icon" src="/img/icons/cancel-blue.svg" @click="closeModal">

        <div v-if="loading" class="loading-container">

            <lottie-loader></lottie-loader>

        </div>

        <div :class="{ 'ghost': loading }" class="padding-modal">

            <h1 class="ms-title">{{ $t('sharing_title_pop_up') }}</h1>

            <div class="foxie-share-container">

                <img class="foxie-share" src="/img/foxy/foxie-land.png">

            </div>


            <div class="logo-share-container">

                <!--                <img class="cicle-share" src="/img/share/circle-facebook.png" @click="share('facebook')">-->

                <img class="cicle-share" src="/img/share/circle-twitter.png" @click="share('twitter')">

                <img class="cicle-share" src="/img/share/circle-whats-app.png" @click="share('whatsapp')">


                <img class="cicle-share" src="/img/share/circle-more.svg" @click="moreShare">

            </div>

            <div v-show="showMore" class="logo-share-container">

                <!--<img class="cicle-share" src="/img/share/circle-messenger.png" @click="share('messenger')">-->

                <img class="cicle-share" src="/img/share/circle-mail.svg" @click="share('email')">
                <!--                <img class="cicle-share" src="/img/share/circle-instagram.png" @click="share('instagram')">-->

                <!--<img class="cicle-share" src="/img/share/circle-sms.svg" @click="share('sms')">-->

                <img class="cicle-share" src="/img/share/circle-linked-in.png" @click="share('linkedin')">

                <!--                <img class="cicle-share" src="/img/share/circle-pinterest.png" @click="share('pinterest')">-->

            </div>


            <button class="btn btn-blue btn-ms" @click="copyLink">{{ $t('sharing_cta_copy_link') }}</button>

        </div>

        <toast ref="toast"></toast>

    </modal>

</template>

<script>

import Share from '@/modules/share'

import ApiFacebook from '@/modules/facebooksdk'

import LottieLoader from '@/components/lottie/LottieLoader'
import Modal from '@/components/modal/Modal'
import Toast from '@/components/Toast'

export default {

    name: 'modal-share',

    components: {LottieLoader, Modal, Toast},

    computed: {

        isMobile() {

            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

        }
    },

    data() {
        return {

            showModal: false,
            showMore: false,
            shared: false,
            dynamic: false,
            loading: false

        }
    },

    mounted() {

        ApiFacebook.initSdk()

    },

    methods: {

        closeModal() {
            this.showModal = false
            this.$emit('close', this.shared)
        },

        open(dynamic = false) {

            this.dynamic = dynamic

            this.showModal = true
        },

        moreShare() {
            this.showMore = true
        },

        share(media) {
            this.loading = true
            this.shared = true
            Share.to(this, media, this.dynamic)
                .finally(() => {
                    this.loading = false
                })
        },

        copyLink() {

            this.loading = true
            Share.to(this, 'copyLink', this.dynamic)
                .finally(() => {
                    this.loading = false
                    this.$refs.toast.open(this.$t('statistics_title_sharing_toast'))
                })

        }

    }

}

</script>

<style lang="scss" scoped>

.padding-modal {
    padding: 21px 0 16px;
    max-width: 490px;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.ghost {
    visibility: hidden;
}

.ms-title {
    font-size: 21px;
    font-weight: bold;
    line-height: 1.14;
    color: $midnight;
}

.foxie-share-container {
    /*width: 100%;*/
    max-width: 490px;
}

.foxie-share {
    width: 100%;
    margin-top: 11px;
}

.logo-share-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 16px;
    width: 100%;
    @media screen and (min-width: $above-tablet-length) {
        justify-content: center;
    }
}

.cicle-share {
    width: 40px;
    height: 40px;
    @media screen and (min-width: $above-tablet-length) {
        margin: 0 16px;
    }
}

.btn-ms {
    margin: 16px;
    width: 224px;
}

.more-container {

}

.close-icon {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 16px;
    right: 16px;

    &:lang(ar-sa) {
        right: initial;
        left: 16px;
    }
}

.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

</style>
